import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { ButtonLikePattern } from '../patterns';
import { SPACING, TEXT_COLORS, TEXT_STYLES } from '../tokens';
import {
  AlertStatusStruct,
  ALERT_STATUS_TO_COLOR_SCHEME,
  ColorSchemeStruct,
} from '../types';
import { resolveColor } from '../utils';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(alertAnatomy.keys);

// Exports
export const Alert = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    icon: { alignSelf: 'baseline' },
    spinner: { alignSelf: 'baseline' },
  }),

  sizes: {
    sm: definePartsStyle({
      container: {
        ...ButtonLikePattern.sizes.layout.sm,
        paddingBlock: SPACING[1],
      },
      icon: {
        marginTop: SPACING['0.5'],
        height: SPACING[4],
        width: SPACING[4],
      },
      spinner: { marginTop: '0.0625rem' },
      title: TEXT_STYLES.sm,
      description: TEXT_STYLES.sm,
    }),

    md: definePartsStyle({
      container: {
        ...ButtonLikePattern.sizes.layout.md,
        paddingBlock: SPACING['1.5'],
      },
      icon: {
        marginTop: SPACING['0.5'],
        height: SPACING[5],
        width: SPACING[5],
      },
      spinner: { marginTop: '0.0625rem' },
      title: TEXT_STYLES.md,
      description: TEXT_STYLES.md,
    }),

    lg: definePartsStyle({
      container: {
        ...ButtonLikePattern.sizes.layout.lg,
        paddingBlock: SPACING['2.5'],
      },
      icon: {
        marginTop: SPACING[0],
        height: SPACING[6],
        width: SPACING[6],
      },
      spinner: { marginTop: SPACING[0] },
      title: TEXT_STYLES.lg,
      description: TEXT_STYLES.lg,
    }),
  },

  variants: {
    subtle: (props) => {
      const status = AlertStatusStruct.parse(props.status);

      const layoutStyles = ButtonLikePattern.variants['solid-muted'].static({
        ...props,
        colorScheme: props.colorScheme
          ? ColorSchemeStruct.parse(props.colorScheme)
          : ALERT_STATUS_TO_COLOR_SCHEME[status],
      });

      return {
        container: {
          ...layoutStyles,
          color: resolveColor(
            { colorMode: props.colorMode, colorScheme: 'gray' },
            TEXT_COLORS.prominent.base,
          ),
        },
      };
    },
  },
});

export type AlertVariant = keyof NonNullable<typeof Alert['variants']>;
